module.exports = __webpack_public_path__ + "img/paarfoto_regenschirm-jump_ocular.2f32ebb1.jpg";